import { Button } from "@capacit-com/lara-law-shared-ui";
import { Pill } from "@capacit-com/lara-law-shared-ui";
import Prompt from "@/models/prompt/prompt";
import { TagType } from "@/models/tag/tag";
import { ArrowLeft } from "lucide-react";
import { FC } from "react";

type PromptLibraryPreviewProps = {
  selectedPrompt: Prompt | undefined;
  handleBackClicked: () => void;
};

const PromptLibraryPreview: FC<PromptLibraryPreviewProps> = ({
  selectedPrompt,
  handleBackClicked,
}) => {
  return (
    <div className="h-full flex flex-col min-w-[600px] p-2 overflow-y-auto">
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <p className="font-semibold text-xl">{selectedPrompt?.title}</p>
        <Button
          onClick={(e) => {
            e.preventDefault();
            handleBackClicked();
          }}
          size="sm"
        >
          <ArrowLeft />
          Tilbage
        </Button>
      </div>

      {/* Metadata Section */}
      <div className="space-y-2 mb-4">
        {/* Departments */}
        <div className="flex items-center gap-2">
          <p className="font-medium whitespace-nowrap">Afdeling:</p>
          <div className="flex flex-wrap gap-1">
            {selectedPrompt?.tags
              .filter((tag) => tag.tagType === TagType.Department)
              .map((tag, idx) => (
                <Pill pillLabel={tag.name} index={idx} />
              ))}
          </div>
        </div>

        {/* Tags */}
        <div className="flex items-center gap-2">
          <p className="font-medium whitespace-nowrap">Tags:</p>
          <div className="flex flex-wrap gap-1">
            {selectedPrompt?.tags
              .filter((tag) => tag.tagType === TagType.Tag)
              .map((tag, idx) => (
                <Pill pillLabel={tag.name} index={idx} />
              ))}
          </div>
        </div>

        {/* Rating */}
        <div className="flex items-center gap-2">
          <p className="font-medium">Bedømmelse:</p>
          <p>{selectedPrompt?.promptRating} %</p>
        </div>
      </div>

      {/* Content Section - Flex grow to fill remaining space */}
      <div className="flex flex-col gap-4 min-h-0 flex-1">
        {/* Description */}
        <div className="flex flex-col min-h-0">
          <p className="font-medium mb-1">Beskrivelse:</p>
          <div className="bg-muted-foreground/15 px-4 py-2 rounded-md h-fit max-h-[12vh] break-words whitespace-normal overflow-auto">
            {selectedPrompt?.description}
          </div>
        </div>

        {/* Prompt */}
        <div className="flex flex-col min-h-0 flex-1">
          <p className="font-medium mb-1">Prompt:</p>
          <pre className="font-sans bg-muted-foreground/15 px-4 py-2 rounded-md h-fit break-words whitespace-normal overflow-auto flex-1">
            {selectedPrompt?.promptString}
          </pre>
        </div>
      </div>
    </div>
  );
};

export default PromptLibraryPreview;
